import { Record } from 'immutable';

const UserRecord = Record({
  username: null,
  email: null,
  firstName: null,
  lastName: null,
  expiration: null,
  allChains: null,
  allBrands: null,
  allProperties: null,
  allArcIatas: null,
  customerInfo: null,
  type: null
});

export class User extends UserRecord {
  username: string;
  email: string;
  firstName: string;
  lastName: string;
  expiration: Date;
  allChains: string[];
  allBrands: string[];
  allProperties: string[];
  allArcIatas: string[];
  customerInfo: string[];
  type: UserType;
}

export enum UserType {
  HOTEL = <any>'HOTEL',
  AGENCY = <any>'AGENCY',
  SUPPORT = <any>'SUPPORT'
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/auth/models/User.ts